import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import 'react-multi-carousel/lib/styles.css';
import ReactPaginate from 'react-paginate';
import * as DOMPurify from 'dompurify';
import Axios from 'axios';
import { useEffect, useState } from 'react'
import { domain } from '../env';

export const ScarsvPage = () => {
    const [scarsvall, setScarsvall] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    
    const getScarsv = async (pageNumber = 1) => {
        setLoading(true);
        await Axios({
            method: "get",
            url: `${domain}/api/scarsv/?page=${pageNumber}`
        }).then(
            response => {
                setScarsvall(response.data.results);
                // Calculate total pages from the count returned by API
                setPageCount(Math.ceil(response.data.count / 6));
                setLoading(false);
                console.log(response.data, "scarsv paginated data");
            }
        ).catch(error => {
            console.error("Error fetching data:", error);
            setLoading(false);
        });
    }

    useEffect(() => {
        getScarsv(1);
    }, []);

    const handlePageClick = (event) => {
        const newPage = event.selected + 1;
        setCurrentPage(event.selected);
        getScarsv(newPage);
        window.scrollTo(0, 600);
    };

    // Initial scroll when component mounts
    useEffect(() => {
        window.scrollTo(0, 600);
    }, []);
    
    return (
        <>
            <section className="page-header">
                <div className="page-header-bg" style={{ 'backgroundImage': 'url(images/v.jpg)' }}>
                </div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>ACTIVITIES</h2>
                        <ul className="thm-breadcrumb list-unstyled">
                            <li><a href="/">Home</a></li>
                            <li><span>/</span></li>
                            <li className="active">ACTIVITIES</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="blog-page">
                <div className="container">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            {scarsvall && scarsvall.map((sc) => (
                                <div className="col-xl-4 col-lg-4 col-md-6" key={sc?.id}>
                                    <div className="blog-one__single">
                                        <div className="blog-one__img">
                                            <LazyLoadImage
                                                effect="blur"
                                                src={`${domain}${sc?.image}`}
                                                alt={sc?.title_english}
                                                width="100%"
                                                height="250px"
                                                threshold={100}
                                                placeholder={<div className="loading-placeholder"></div>}
                                            />
                                            <div className="blog-one__date">
                                                <p>{sc?.createdat}</p>
                                            </div>
                                            <a href={`/scarsvdetails${sc?.id}`}>
                                                <span className="news-one__plus"></span>
                                            </a>
                                        </div>
                                        <div className="blog-one__content">
                                            <ul className="list-unstyled blog-one__meta">
                                                <li><a href="#"><i className="far fa-user-circle"></i> Scarsv</a></li>
                                            </ul>
                                            <h3 className="blog-one__title">
                                                <a href={`/scarsvdetails${sc?.id}`}>{sc?.title_english}</a>
                                            </h3>
                                            <p className="causes-one__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${sc?.details_English.slice(0, 100)}...`) }} />
                                            <div className="blog-one__bottom">
                                                <a href={`/scarsvdetails${sc?.id}`} className="blog-one__btn">Read More</a>
                                                <a href={`/scarsvdetails${sc?.id}`} className="blog-one__arrow"><span
                                                    className="icon-right-arrow"></span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {pageCount > 1 && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="pagination-container text-center mt-4">
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel={<i className='fas fa-angle-double-right' />}
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={1}
                                        pageCount={pageCount}
                                        previousLabel={<i className='fas fa-angle-double-left' />}
                                        renderOnZeroPageCount={null}
                                        containerClassName='pagination'
                                        pageClassName='page-num'
                                        previousLinkClassName="page-num"
                                        nextLinkClassName="page-num"
                                        forcePage={currentPage}
                                        activeLinkClassName="active"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}
